module.exports = __webpack_public_path__ + "img/logo.b0d5d7ab.png";